/**
 * Class ApiRouter.js
 *
 * @class ApiRouter
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.11] app/src/manager/ApiRouter.js
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default class ApiRouter {
  constructor(baseUrl) {
    /** @type string */
    this._baseUrl = baseUrl

    this._paths = {}

    this._defaultParameters = null

  }

  getRoute(path, parameters, queryParameters) {
     if (Object.prototype.hasOwnProperty.call(this._paths, path)){
       let url = this._baseUrl + this._paths[path](parameters)

       queryParameters = Object.assign({}, this._defaultParameters || {}, queryParameters || {})

       if (queryParameters) url = addObjectToUrlAsQueryString(url, queryParameters)

       return url
     }else{
       throw new Error(`Unknown path: ${path}`)
     }
  }

  addRoute(path, fn){
    this._paths[path] = fn
  }

  addDefaultParameter(parameter, value){
    if (this._defaultParameters === null)
      this._defaultParameters = {}

    this._defaultParameters[parameter] = value
  }
}

function addObjectToUrlAsQueryString(url,parts){
  const objectKeys = Object.keys(parts ? parts : {});

  if (!objectKeys.length) return url;

  const paramString = objectKeys
    .map(key => `${key}=${parts[key]}`)
    .join('&')

  return url + (url.includes('?') ? '&' : '?') + paramString
}